
import { ProfileCount, UserProfileViewArgs, getProfileViewCount } from '../assets/ts/data/user-profile-view'
import useServerData from './use-server-data'
  
  
  function useProfileCount(fetchArgs: UserProfileViewArgs) {
    const {
      data: profileCount,
      error: profileCountError,
      fetchData: fetchProfileCount,
      isLoading: profileCountIsLoading,
  
    } = useServerData<ProfileCount, UserProfileViewArgs>(
      getProfileViewCount,
      fetchArgs
    )
    const count = profileCount?.[0]?.ID_count ?? 0

    return {
      fetchProfileCount,
      profileCount, 
      profileCountError,
      profileCountIsLoading,
      profileCountValue: count,
    }
  }
  
  export default useProfileCount
  